// extracted by mini-css-extract-plugin
module.exports = {"description":"Privacy_description__2P9sG"};